import { useEffect, useRef } from "react";
import { getBaseUrl } from "services/common";
import { useRecoilState } from "recoil";
import { toastState } from "atoms";
import { CartModel } from "atoms/models";
import { parseTemplate } from "url-template";
import { useNavigate } from "react-router-dom";

const srcTemplate = parseTemplate("ecommerce/payment");

const PaymentForm: React.FC<{ cart: CartModel }> = ({ cart }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const targetOrigin = window.origin;
  const [toast, setToast] = useRecoilState(toastState);
  const navigate = useNavigate();

  const checkMessageOrigin = (message: any) => {
    return targetOrigin && message.origin && targetOrigin === message.origin;
  };

  const handleUninitialized = (eventData: any) => {
    const totalAmountDueFormatted = cart?.totalAmountDue ? cart.totalAmountDue.replace(/,/g, "") : cart.totalAmountDue;
    const iframe = iframeRef.current;
    if (iframe) {
      const message = {
        type: "INITIALIZE",
        payload: {
          amount: totalAmountDueFormatted,
        },
      };
      iframe.contentWindow?.postMessage(message, targetOrigin);
    }
  };

  const handleIdle = (action: any) => {
    if (action.error) {
      dispatchError(JSON.parse(action.payload.errorMessage));
    }
  };

  const handlePending = (action: any) => {
    // Handle pending action if needed
    console.log("HANDLE PENDING");
  };

  const shopPortalhandleComplete = (eventData: any) => {
    handleComplete(eventData.event.payload);
  };

  const handleComplete = (payload: any) => {
    const links = payload["_links"];
    const windowLocation = "ec:windowLocation";

    if (links && links[windowLocation] && links[windowLocation].href) {
      navigate(links[windowLocation].href);
    }
  };

  const dispatchError = (payload: any) => {
    setToast({
      ...toast,
      show: true,
      variant: "danger",
      header: "Error",
      message: payload.message,
    });
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    window.addEventListener("shopPortalPaymentComplete", handleMessage);
    window.addEventListener("refreshShop", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      window.removeEventListener("shopPortalPaymentComplete", handleMessage);
      window.removeEventListener("refreshShop", handleMessage);
    };
    // eslint-disable-next-line
  }, []);

  const baseUrl = getBaseUrl();
  const relativeUrl = srcTemplate.expand({});
  const src = new URL(relativeUrl, baseUrl).href;

  const handleMessage = (event: any) => {
    if (checkMessageOrigin(event) && event && event.data) {
      switch (event.data.type) {
        case "UNINITIALIZED":
          handleUninitialized(event.data);
          break;
        case "IDLE":
          handleIdle(event.data);
          break;
        case "PENDING":
          handlePending(event.data);
          break;
        case "COMPLETE":
          handleComplete(event.data.payload);
          break;
        default:
          break;
      }
    } else if (event.data.shopPortalPaymentComplete) {
      shopPortalhandleComplete(event.data);
    } else if (event.data === "refreshShop") {
      window.location.reload();
    }
  };

  return (
    <div className="payment-section-container container">
      <div className="payment-section-title row mb-2">
        <h5>
          <strong>Card Information</strong>
        </h5>
      </div>
      {cart && cart.ecommerceStatus?.includes("order_confirmed") && cart.ecommerceStatus !== "order_confirmed_bypass_payment" ? (
        <div style={{ width: "800px%" }}>
          <iframe
            ref={iframeRef}
            src={src}
            width="100%"
            height="700"
            frameBorder="0"
            title="Comporium Shop Payment"
            sandbox="allow-scripts allow-same-origin"
          />
        </div>
      ) : (
        <div>No cart or invalid cart status</div>
      )}
    </div>
  );
};

export default PaymentForm;
